import { PhaseOutput } from 'phase/model/phase.output';
import { Phase } from 'phase/phase';

export abstract class PhaseConverterPort {
	public abstract phasesAsEntities(outputs: PhaseOutput[]): Phase[];
}
